import { render } from '@wordpress/element';
import App from './App/app';
import { CartProvider } from './App/CartContext';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('pscfw_SideCart');

  if (root) {
    render(
      <CartProvider>
        <App />
      </CartProvider>
      ,root
    );
  }
});
